import React from "react";
import { Modal } from "react-bootstrap";
import "./UsersMonitoring.css";

const UserContext = React.createContext(null);
const TitleContext = React.createContext("");
let nextModalId = 0;
const flatten = (children) => React.Children.toArray(children).flatMap((child) =>
  child.type === React.Fragment ? flatten(child.props.children) : [child]);

export default function UsersModal({ children, selectedUser, className = "", contentClassName, size, ...props }) {
  const [titleId] = React.useState(() => `users-dialog-title-${++nextModalId}`);
  const sections = flatten(children);
  const hasFooter = sections.some((child) => child.type === Modal.Footer);
  return (
    <UserContext.Provider value={selectedUser}>
      <TitleContext.Provider value={titleId}>
        <Modal {...props} size="lg" centered scrollable aria-labelledby={titleId} className={`users-modal ${className}`} contentClassName="users-modal-content">
          {sections}
          {!hasFooter && <Modal.Footer><button type="button" className="users-button users-button-secondary" onClick={props.onHide}>Tutup</button></Modal.Footer>}
        </Modal>
      </TitleContext.Provider>
    </UserContext.Provider>
  );
}

UsersModal.Header = Modal.Header;
UsersModal.Title = function UsersModalTitle(props) {
  return <Modal.Title {...props} id={React.useContext(TitleContext)} />;
};
UsersModal.Footer = Modal.Footer;
UsersModal.Body = function UsersModalBody({ children, ...props }) {
  const user = React.useContext(UserContext);
  return (
    <Modal.Body {...props}>
      {user && <div className="users-modal-identity">
        <span className="users-avatar" aria-hidden="true">{(user.nama || "U").trim().slice(0, 1).toUpperCase()}</span>
        <div><small>PENGGUNA DIPILIH</small><strong>{user.nama || "—"}</strong><span>{user.nopeg || user.kodeUser || "—"} · {user.role || "Pengguna"}</span></div>
      </div>}
      {children}
    </Modal.Body>
  );
};
